import IconBase from "./IconBase";

// A key — credentials, and identifiers that unlock a specific record.
// The bow is kept small against a long, toothed shaft: at a larger ratio the
// glyph collapses into a magnifying glass, which the bar already uses for search.
const KeyIcon = (props) => (
    <IconBase {...props}>
        <circle cx="7.75" cy="7.75" r="3.5" />
        <path d="M10.25 10.25L20.5 20.5" />
        <path d="M17.5 17.5L15.6 19.4" />
        <path d="M14.75 14.75L12.85 16.65" />
    </IconBase>
);

export default KeyIcon;
